export const defaultCoordinates = {
  latitude: 10.77253621500006,
  longitude: 106.69798153800008,
}

export const defaultImage =
  "https://media.be.com.vn/bizops/image/61ac0642-26e3-11ee-bfaa-82e52b34e173/original"
